import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ChangeDetectionStrategy } from '@angular/core';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import { Observacion } from '../../models/observacion/observacion.model';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

declare const Rut: any;
declare const ageCalculator: any;

export interface DialogData {
  rut: any,
  dv: any,
  termino: any,
  motivo: string,
  fechaDesafiliacion: any
  fechaRechazo: any
}

@Component({
  selector: 'app-observacion-historico',
  templateUrl: '../../pages/afiliacion/dialog-observacion-historico.component.html',
  styleUrls: ['../../pages/solicitud-afiliacion/solicitud-afiliacion.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DialogObservacionHistoricoComponent implements OnInit, OnDestroy {

  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  rutAfiliado: string = localStorage.getItem("rutAfiliado")
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario: any;
  fechaRechazo: any;
  motivo: string;
  termino: any;
  rut: any;
  mostrarDatosCargados: boolean;
  observaciones: Observacion[];
  afiliado: any = { rut: "", sub: "", name: "", nombres: "", idAfiliado: '', email: '', nombreAfiliado: '', apellidoAfiliado: '' };

  constructor(private router: Router,
    public dialogRef: MatDialogRef<DialogObservacionHistoricoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,
    private postulacionesService: PostulacionesService,
    private afiliacionService: AfiliacionService) {
    let vm = this
    console.log(vm.data)
    this.data.termino = false

  }

  ngOnInit(): void { this.loadData() 
  }

  loadData() {
    let vm = this     
    this.afiliacionService.getObservacionesUsuario(vm.data.rut.split('-')[0]).then
        (
            (observacionUsuario: any) => {
                vm.observaciones = observacionUsuario               
            }
        )
        .catch(error => {
            console.log(error)
            Swal.close();
            vm.openAlertDialog("No hay registros disponibles.", "btn-danger")
        })
}

  ngOnDestroy(): void {
  }



  casoExitoso() {
    this.router.navigate(['/login'])
  }
  casoFallido() {
    this.router.navigate(['/solicitud-afiliacion'])
  }
 /*
 getObservacionesUsuario
 */



  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  onCancelarClick(): void { this.dialogRef.close() }
}
